module.exports = __webpack_public_path__ + "static/47308239_2198759670157737_4323923806595842048_o_optimized-071c9394ae4ef46516249a2e785b5b21.jpg";